<template>
	<vue-multiselect
		style="width: 300px"
		placeholder="Selecteer sortering"
		v-model="value"
		:options="selectOptions"
		:show-labels="false"
		:allow-empty="false"
		track-by="name" label="name"
	/>
</template>

<script>
export default {
	data() {
		return {
			value: {
				value: 'dateOldNew',
				name: 'Besteldatum oud-nieuw'
			},
			selectOptions: [
				{
					value: 'dateOldNew',
					name: 'Besteldatum oud-nieuw'
				},
				{
					value: 'ean',
					name: 'EAN'
				},
				{
					value: 'location',
					name: 'Opslaglocatie'
				},
				{
					value: 'internalReference',
					name: 'Interne referentie'
				},
				{
					value: 'internalReferenceAmount',
					name: 'Interne referentie + aantal'
				},
			]
		}
	},
	watch: {
		'value'(newSort) {
			this.$parent.sortChange(newSort.value);
		}
	}
}
</script>
